module.exports = {
  ios: {
    'letvBee': 'https://apps.apple.com/cn/app/bee语音-声音交友/id1472985872',
    'bee': 'https://apps.apple.com/cn/app/Bee语音/id1463949840'
  },
  /**
   * 230110000  官网渠道
   * 230110015  乐视视频导流h5
   * 230110016  M站下载页
   * 230114013  房间分享落地页 
   * 220110000  乐视语音版下载页
   * 240110000  闪音交友下载页
   * 340110000  Bee直播下载页
   * &version=  指定版本
   */ 
  android: {
    0: 'https://api-svoice.le.com/app/download?pcode=230110000',
    15: 'https://api-svoice.le.com/app/download?pcode=230110015',
    16: 'https://api-svoice.le.com/app/download?pcode=230110016',
    380: 'http://cdn.svoice.le.com/uploads/fb/4e/fb4ead0643ddfc5b78e5017d8dcbdcdf.apk',
    4013: 'https://api-svoice.le.com/app/download?pcode=230114013',
    230110000: 'https://api-svoice.le.com/app/download?pcode=230110000',
    230110015: 'https://api-svoice.le.com/app/download?pcode=230110015',
    230110016: 'https://api-svoice.le.com/app/download?pcode=230110016',
    230114013: 'https://api-svoice.le.com/app/download?pcode=230114013',
    220110000: 'https://api-svoice.le.com/app/download?pcode=220110000',
    240110000: 'https://api-svoice.le.com/app/download?pcode=240110000',
    220114016: 'https://api-svoice.le.com/app/download?pcode=220210000',
    'test': 'http://test.cdn.svoice.le.com/uploads/76/0c/760c169fd2e3d0385275952b88ba35ae.apk'
  }
}
